/**
 * localePath — prefix an internal app path with the active locale (Story 4.1).
 *
 * Pure function (no React). The locale-aware link layer (`<LocaleLink>`) and any
 * call site that has a code in hand use this to keep navigation inside the active
 * locale. It is deliberately a no-op when there is no active locale (`code` is
 * null/undefined) so the same shared components render unchanged on the sandbox
 * routes that sit *outside* `:lang` — that is what preserves behavior 1:1 (NFR9).
 */
export function localePath(code: string | null | undefined, to: string): string {
  // No active locale (sandbox / outside :lang), or not an internal absolute path
  // (external https:/mailto:, hash #anchor, relative) → leave untouched.
  if (!code || !to.startsWith("/")) return to;
  // "/" → "/nl"; "/features#vehicles" → "/nl/features#vehicles" (sub-path + hash + query preserved).
  return `/${code}${to === "/" ? "" : to}`;
}
